import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";

export const fetchUIDGallery = createAsyncThunk(
  "fetchUIDGallery",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/UIDsearch",

        {
          UID: data1,
          
        },
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      console.error("!!!", error);
      if (error?.response?.status > 399) {
        localStorage.clear();
        window.location.assign("/");
      }
      if (error.code === "ERR_NETWORK") {
        return rejectWithValue("ERROR");
      }
    }
  }
);

const galleryUIDSlice = createSlice({
  name: "galleryUID",
  initialState: {
    data: null,
  },
 
  extraReducers: (builder) => {
    builder
      .addCase(fetchUIDGallery.fulfilled, (state, action) => {
          state.data = action.payload;
      });
  },
});

export default galleryUIDSlice.reducer;
